import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Services.css';

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/services/')
      .then(res => setServices(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="services-page">
      <div className="page-header container">
        <p className="services-eyebrow">Ce que nous proposons</p>
        <h1 className="section-title">Nos <span>Services</span></h1>
        <div className="gold-line centered" />
        <p className="section-subtitle">
          Une gamme complète de prestations automobiles réalisées par des techniciens qualifiés.
        </p>
      </div>

      <div className="container services-body">
        {loading ? (
          <p className="loading-text">Chargement...</p>
        ) : services.length === 0 ? (
          <p className="empty-text">Aucun service disponible pour le moment.</p>
        ) : (
          <div className="services-list">
            {services.map((service, i) => (
              <div className="service-item" key={service.id}>
                <div className="service-number">0{i + 1}</div>
                <div className="service-content">
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                </div>
                <div className="service-price-tag">{service.price} €</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Services;
